import { AnalyticsEventFactory } from '@salsita-ai/platform-project-sdk/domain'

const ConfiguratorFinalized = (price: number) => {
  return AnalyticsEventFactory.UserActionEvent({
    section: 'finalizePage',
    element: 'submitButton',
    action: 'click',
    data: {
      price: Math.round(price * 100) / 100,
    },
  })
}

export const analyticsEvents = {
  ConfiguratorFinalized,
}
